<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="550px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span v-if="isNew" class="headline">Add category</span>
          <span v-if="!isNew" class="headline">{{ model.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.name"
                        required
                        :rules="[required]"
                        label="Name"
                        :error-messages="errorMessages"
                        :disabled="saving"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                        v-model="edited.sectionId"
                        :disabled="saving"
                        :items="sections"
                        :rules="[required]"
                        item-text="name"
                        item-value="id"
                        label="Section"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <ImageInput v-model="edited.image" :suggest="edited.name" :aspect-ratio="60/71" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Отменить</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { CategoriesApi } from '../common/api'
import { ADD_CATEGORY, UPDATE_CATEGORY } from '../store/mutation-types'
import { mapState } from 'vuex'
import ImageInput from './ImageInput'

const COMMON_ERROR = 'Error has occurred while saving'

export default {
  components: { ImageInput },
  props: ['value', 'model'],
  data () {
    return {
      valid: false,
      saving: false,
      errorMessages: [],
      errorOnSave: COMMON_ERROR,
      showErrorOnSave: false,
      edited: this.defaultModel()
    }
  },
  computed: {
    isNew () {
      return !this.model
    },
    ...mapState([
      'sections'
    ])
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      if (this.isNew) {
        this.edited = this.defaultModel()
      } else {
        this.edited = { ...this.model }
      }
    }
  },
  methods: {
    defaultModel () {
      return {
        name: '',
        image: null,
        sectionId: null
      }
    },
    validate () {
      this.errorOnSave = COMMON_ERROR
      if (this.edited.image === null) {
        this.errorOnSave = 'Image is required'
        this.showErrorOnSave = true

        return false
      }
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        if (this.isNew) {
          const { data } = await CategoriesApi.create(this.edited)
          this.$store.commit(ADD_CATEGORY, data)
        } else {
          const { data } = await CategoriesApi.update(this.edited)
          this.$store.commit(UPDATE_CATEGORY, data)
        }
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
